import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-about-summary',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './about-summary.component.html',
  styleUrls: ['./about-summary.component.scss']
})
export class AboutSummaryComponent {
  /** Home shows the condensed version with a link out; the About page shows the full version inline. */
  @Input() condensed = false;
}
